import { render, staticRenderFns } from "./EvaluationCategorySettingsPage.vue?vue&type=template&id=1918c98e&scoped=true"
import script from "./EvaluationCategorySettingsPage.vue?vue&type=script&lang=js"
export * from "./EvaluationCategorySettingsPage.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCategorySettingsPage.vue?vue&type=style&index=0&id=1918c98e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918c98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1918c98e')) {
      api.createRecord('1918c98e', component.options)
    } else {
      api.reload('1918c98e', component.options)
    }
    module.hot.accept("./EvaluationCategorySettingsPage.vue?vue&type=template&id=1918c98e&scoped=true", function () {
      api.rerender('1918c98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/evaluation/EvaluationCategorySettingsPage.vue"
export default component.exports